import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Modal } from 'reactstrap';
import { get, post, put, del } from 'helpers/api_helper';
import Datatables from 'pages/utils/table/datatable';
import { ManageTagColumns } from './tableColumns';
import { LANGUAGES_URL } from 'helpers/url_helper';
import { showSuccessAlert, showConfirmAlert } from "pages/utils/alertMessages";
import { AvForm, AvField } from 'availity-reactstrap-validation';

const ManageLanguage = () => {
    const [isForm, setIsForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [rows, setRows] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, Search: '' });

    const fetchData = async () => {
        const { success, body } = await get(`${LANGUAGES_URL}?page=${pagination.page}&limit=${pagination.limit}&search=${pagination.Search}`);
        if (success) {
            setLoading(true);
            setRows(body?.body || body);
            setLoading(false);
        }
    };

    useEffect(fetchData, [pagination]);

    const handleToggle = () => {
        setIsForm(!isForm);
        setEditMode(false);
        setEditingId(null);
        setFormData({});
        setLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        const url = editMode ? `${LANGUAGES_URL}/${editingId}` : LANGUAGES_URL;
        const method = editMode ? put : post;

        const { success, body } = await method(url, formData);

        if (success) {
            showSuccessAlert(editMode ? 'Language updated successfully!' : 'Language created successfully!');
            setIsForm(false);
            setFormData({});
            setEditMode(false);
            setEditingId(null);
            fetchData();
        }
    };

    const handleInvalidSubmit = () => {
        alert("Please enter the required fields.");
    };

    const handleEdit = (row) => {
        setFormData(row);
        setEditMode(true);
        setEditingId(row.id);
        setIsForm(true);
        setLoading(false);
    };

    const handleDelete = async (id, sts) => {
        const action = sts === 1 ? 'De-activate' : 'Activate';

        const { isConfirmed } = await showConfirmAlert(`${action} this Language`, `Do you really want to ${action} this Language?`,
            `Yes, ${action} it!`, `${action}d!`, `Language has been ${action}d successfully.`);

        if (isConfirmed) {
            const { success } = await del(`${LANGUAGES_URL}/${id}?sts=${sts}`);
            if (success) {
                fetchData();
            }
        }
    };

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Datatables
                        isSearch={true}
                        columns={ManageTagColumns({ "edit": handleEdit, "delete": handleDelete }, pagination)}
                        showTableOnly={true}
                        rowsLength={rows?.totalItems || 0}
                        rows={rows?.items || []}
                        keyField={'id'}
                        handleAddButton={handleToggle}
                        title="All Supported Languages"
                        isAdd={true}
                        isTableHead={true}
                        loading={loading}
                        ssr={setPagination}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={isForm} toggle={handleToggle} size="xl" centered>
                <AvForm onValidSubmit={handleSubmit} onInvalidSubmit={handleInvalidSubmit} model={formData}>
                    <div className="modal-header">
                        <h5 className="modal-title font-weight-bold">
                            {editMode ? 'Update' : 'Add'} Language
                        </h5>
                        <button type="button" className="btn-close" onClick={handleToggle} aria-label="Close" />
                    </div>
                    <div className="modal-body p-4">
                        <Row className="g-3">
                            <Col md={12}>
                                <div className="mb-2">
                                    <AvField
                                        name="title"
                                        label="Language Name *"
                                        type="text"
                                        placeholder="e.g. English, Hindi, Marathi, Gujarati, Telugu, Tamil"
                                        value={formData.title || ''}
                                        onChange={handleChange}
                                        required
                                        errorMessage="Please enter Language name"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" onClick={handleToggle}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Processing...' : (editMode ? 'Update Language' : 'Save Language')}
                        </button>
                    </div>
                </AvForm>
            </Modal>
        </React.Fragment>
    );
};

export default ManageLanguage;